export default {"src":"/_next/static/media/subTitle.bb554c96.svg","height":62,"width":128};